import S from './spinner';

const Spinner = S;

export default Spinner;
